export const PRODUCTS_VIEWED_KEY = 'perpay.products.viewed';
